var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main__layout"},[_c('transition',{attrs:{"name":"zoom-fade","mode":"out-in"}},[_c('router-view',{on:{"changeRouteTitle":_vm.changeRouteTitle}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }